import * as React from "react";
import * as Yup from 'yup';
import { Formik, Form, FieldArray, getIn } from 'formik';
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from '@mui/material/FormControl';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import CustomSelect from "../CustomComponents/CustomSelect";
import Autocomplete from '@mui/material/Autocomplete';
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { makeStyles } from "@mui/styles";
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import Fade from '@mui/material/Fade';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import BorderColorRoundedIcon from '@mui/icons-material/BorderColorRounded';
import { logger, checkAuthentication } from '../../utils';

const pageStyles = makeStyles(theme => ({
    root: {
        "& .MuiPaper-root": {
            color: "#ffffff",
            overflowy: "hidden"
        },
        "& .Mui-checked": {
            color: "#1f1b1e"
        },
        "& .MuiSvgIcon-root": {
            color: "#1f1b1e",
            colorPrimary: "#1f1b1e",
            fill: "#1f1b1e",
        },
        "& .MuiTypography-root": {
            color: "#000000"
        },
        "& .MuiMenu-paper": {
            color: "#000000"
        },
        "& .MuiFormControl-root": {
            color: "#000000"
        },
    },

}));

export default function EditTaskDialog({ handleEditCallback, data }) {
    const [refresh, setRefresh] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [isLoaded, setIsLoaded] = React.useState(false);
    const [dataRequest, setDataRequest] = React.useState(false);
    const timerRef = React.useRef(null);
    const [ValueAlert, setAlert] = React.useState(false);
    const [saveAlert, setSaveAlert] = React.useState(false);
    const [newItem, setNewItem] = React.useState('');
    const [radio, setRadio] = React.useState('');
    const classes = pageStyles();
    const [ProjectChoices, setProjectChoices] = React.useState([]) 
    const [ProjectGroupChoices, setProjectGroupChoices] = React.useState([])
    const [taskItemChoices, setTaskItemChoices] = React.useState([]);
    const [optionList, setOptionList] = React.useState([]);    
    const [projectGroup, setProjectGroup] = React.useState()
  //  const [activeGroup, setActiveGroup] = React.useState()		
    logger(`start of Edit`, data)
	const [updateName, setUpdateName] = React.useState('');
  	logger("updateName in top ", updateName)
  	logger("NewItem in top", newItem)

    const initialValues = {
        Name: updateName,
        Project: data.ProjectID,
        TaskGroup: data.GroupID,
        TaskType: data.TaskType,
        ProjectGroup: projectGroup,
        IsActive: data.IsActive ? true : false,
        IsBillable: data.IsBillable ? true : false,
        propList: optionList
    }
    logger("initialValues on top", initialValues )
 
   
    const validFormSchema = Yup.object({
        Name: Yup
            .string('Enter a name for this Group Name')
            .required('Name is required'),
        Project: Yup
            .string('Please enter the Project.')
            .required('Project is required'),
       TaskGroup: Yup
            .string('Please enter the Task Group.')
            .required('Task Group is required'),
        IsActive: Yup
            .boolean(),
        IsBillable: Yup
            .boolean(),
        propList: Yup.array().of(
            Yup.object().shape({

            })
        )

    })

    const onTrigger = React.useCallback((values) => {
        const msg = {
            Name: values.Name,
            ProjectID: values.Project,
            GroupID: values.TaskGroup,
            IsActive: values.IsActive ? 1 : 0,
            IsBillable: values.IsBillable ? 1 : 0,
            ID: data.ID,
            optionList: values.propList
        };
        setDataRequest(false)
        handleEditCallback(msg);
		setRefresh(true);
        handleClose();
    })

    const handleClickOpen = () => {
     //   logger(`ClickOpen`)
     	setUpdateName(data.Name)
        setOpen(true);
        setRefresh(true);
     //   logger(`pG on open`, projectGroup)
    };

    const handleClose = () => {
		//setOptionList(),
		setUpdateName(''),
        setOpen(false);
        setRefresh(false);
        setOptionList([]);
       // setProjectChoices([]);
        setProjectGroupChoices([]);
        setTaskItemChoices([]);
    };

  /*  const handleAlert = (value, VariableID, VariableName) => {
       logger(`handleAlert`, value)
        setNewItem({ Name: value, TaskVariableID: VariableID, VariableName: VariableName })
     //   logger('setAlert will be called')
        setAlert(true);
    };*/
    
    
	const handleAlert = (value, VariableID, VariableName) => {
		// Check if the new item is already in the taskItemChoices
		const itemExists = taskItemChoices.some(
			taskItem => taskItem.TaskVariableID === VariableID && taskItem.label === value
		);
		if (!itemExists) {
			setNewItem({ Name: value, TaskVariableID: VariableID, VariableName: VariableName, isNew: true });
			setAlert(true);
		} else {
			logger("Item already exists, no need to trigger alert.");
		}
	};

	const setTaskPropItemValue = (p, props, index) => {
		logger("Props values in my function", props.values)
		logger("newItem in my function", newItem)		
		var TkItem = taskItemChoices.filter(taskItem => taskItem.TaskVariableID == p.TaskVariableID && taskItem.label === newItem.Name && newItem.isNew === true);
		logger("tkitem", TkItem)
		if (TkItem.length > 0) {
			var updateProps = props.values.propList[index].TaskItem = TkItem[0].value;
			logger("updateProps", updateProps)
			const updateProp = props.values.propList			
			logger("updateProp", updateProp)
			setOptionList(updateProp);
			logger("OptionList", optionList)
			logger("Initialvalues with prop list ", initialValues.propList)
			logger("Initialvalues", initialValues)
			logger("Props values end of function", props.values.Name)
		} else {
			TkItem = null;
			//logger("TkItem is empty or undefined");
		}
	}


    function handleNewItem(Name, TaskVariableID) {
        logger('handleNewItem', Name , TaskVariableID )
    //    logger(Name)
        fetch("api/taskItem", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "taskItem": {
                    "Name": Name,
                    "TaskVariableID": TaskVariableID
                }
            })
        })
        getTaskItem();
        setRefresh(true);
    };
    
	const handleAlertClose = () => {
		setAlert(false);
	};

	const handleSaveAlertClose = () => {
		setSaveAlert(false)
	};
	const wait = () => {
		if (timerRef.current) {
            clearTimeout(timerRef.current);
        }
      //  if (!newColumns.length) {
            timerRef.current = setTimeout(() => {
                if (!projectGroup) {
                    setRefresh(true)
                }
                //   setNext(true)              
            }, 1000);
       // }
    }

    const getProps = async (data) => {
        await fetch(`/api/task_variable/edit/${data.GroupID}/${data.ID}`, {
            method: 'Get',
        })
            .then(res => res.json())
            .then(json => {
                setOptionList(json)
           //     setActiveGroup(projectGroup)
                
            })
            .then(json => {
                if (!optionList[0]) {
                    //    timerRef.current = setTimeout(() => {
                 //   logger(`if No optionList`, optionList)
                    //        logger(`No OL Choices`, choices)
                    setIsLoaded(false)
                    setRefresh(true)
                    //  }, 2000);
                } else {
                    //   logger(`optionList Test passed`)
                    setDataRequest(true)
                    setIsLoaded(true)
                    
                }

            })

    }

    const getTaskItem = async () => {
        await fetch('api/task_prop_item', {
            method: 'Get',
        })
            .then(res => res.json())
            .then(json => {
                let choices = [];
                json.forEach(choice => choices.push({ label: choice.Name, value: choice.ID, TaskVariableID: choice.TaskVariableID }))
                setTaskItemChoices(choices)
               
            })
    }
    const getProjectGroup = async () => {
        await fetch('api/projectGroup', {
            method: 'Get',
        })
            .then(res => res.json())
            .then(json => {
                let choices = [];
                json.forEach(choice => choices.push({ label: choice.Name, value: choice.ID }))
                setProjectGroupChoices(choices)
                
            })
       
    }
	const getProject = async (activeGroup) => {
		var PGChoice;
		if (activeGroup) { PGChoice = (activeGroup) } else {
			if (projectGroup) { PGChoice = (projectGroup) } else { PGChoice = (data.ProjectGroupID) }
		}
		await fetch(`/api/project/limiteddropdown/${PGChoice}`, {
			method: 'Get',
		})
			.then(res => res.json())
			.then(json => {
				logger(`------in setProject`,projectGroup)
				let choices = [];

				json.forEach(choice => choices.push({ label: choice.Name, value: choice.ID }))
				setProjectChoices(choices)
				activeGroup = null;
				//wait();
			})
	}

       
 
	const handlePGChange = async (event) => {
	console.log("handlePGChange value=", event);
    setProjectGroup(event);
    props.setFieldValue("ProjectGroup", event);
    await getProject(event); 
    setRefresh(true);
   };

const handleProjectChange = (event) => {
	console.log("handleProjectChange value=", event);
    setProjectOption(event);
    props.setFieldValue("Project", event); 
    setRefresh(true);
};
    
  
    const GetTask = async () => {
        const response = await fetch(`/api/Task/dropdown`, {
            method: 'Get',
        })
            .then(res => res.json())
            .then(json => {
                return json;
            });
        return response;
    }

    const CheckTask = async (taskList, task) => {
     //   logger(taskList)
      //  logger(task)
        let output = false;

        taskList.forEach((item, index) => {
            if (item.Name === task.Name && data.ID != item.ID) {
                setSaveAlert(true);
                output = true;
            }
        })

        if (!output) {
            onTrigger(task);
       //     logger('will be saved')
        }
    }

	const checkDisabled = (newItem, p) => {
		return newItem.TaskVariableID == p.TaskVariableID && taskItemChoices && (taskItemChoices.filter(taskItem => taskItem.label == newItem.Name).length > 0 ? false : true) ? false : true;
	}
    React.useEffect(() => {
       
       
        if (refresh) {
			checkAuthentication();
      //      logger(`in refresh`)
            if (open) {
                if (projectGroup) {
        //            logger(`REFRESH-`, projectGroup)
                } else {
                    setProjectGroup(data.ProjectGroupID)
                }
                getProps(data)
                .then(getProjectGroup())
                    .then(getProject())
                    .then(getTaskItem())
         //       logger(`ProjectChoices `, ProjectChoices)

            }
        }
        setRefresh(false)
    })
 /*   { logger(`props`, props.values) }
    { logger(`optionList`, optionList) }*/

    return (
        <div>
            <Tooltip title="Edit Task" placement="top-end">
            <IconButton variant="contained" onClick={handleClickOpen} >
                <BorderColorRoundedIcon color="primary" />
                </IconButton>
            </Tooltip>
            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">
            
                <DialogContent> 
                    <Formik
                        initialValues={initialValues}
                        enableReinitialize
                        validationSchema={validFormSchema}
                        validateOnChange={false}
                        onSubmit={(values, { resetForm }) => {
                            GetTask()
                                .then(response => CheckTask(response, values))
                                .then(resetForm())
                        }}
                    >
                        {props => (

                            <Form>
                           
                                <AppBar sx={{ position: 'relative' }}>
                                    <Toolbar>
                                        <IconButton
                                            edge="start"
                                            color="inherit"
                                            onClick={handleClose}
                                            aria-label="close"
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                        <Typography sx={{ ml: 2, flex: 1, color:"white" }} variant="h6" component="div" >
                                            Edit Task
                                        </Typography>
                                       <Button autoFocus color="inherit" onClick={props.handleSubmit}>
                                            save
                                        </Button>
                                    </Toolbar>
                                </AppBar>
                                
                                <DialogTitle className={classes.root}>Task Info:</DialogTitle>
                                 <Grid container spacing={1}  pl={1}>
                                    <Grid item xs={4} md={3}>
                                        <div>
                                            <FormControl sx={{ m: 1, width: 240 }}>
                                                <TextField
                                                    disabled
                                                    name='TaskGroup'
                                                    id="outlined-TaskType"
                                                    labelId="outlined-TaskType"
                                                    label="TaskType"
                                                    value={props.values.TaskType}
                                                    helperText={props.touched.Name && props.errors.Name}
                                                />
                                            </FormControl>
                                        </div>
                                        
                                        <div>
                                            <FormControl sx={{ m: 1, width: 240 }}>
                                                <InputLabel>ProjectGroup</InputLabel>
                                            	<CustomSelect
													name="ProjectGroup"
													id="outlined-ProjectGroup"
													options={ProjectGroupChoices}
													onBlur={props.handleBlur}
													value={props.values.ProjectGroup}
													error={props.touched.ProjectGroup && Boolean(props.errors.ProjectGroup)}
													helperText={props.touched.ProjectGroup && props.errors.ProjectGroup}
													label="ProjectGroup"
													disabled={data.IsBilled === 1}
													onChange={(e) => {
														setProjectGroup(e.target.value);
														handlePGChange(e.target.value);
													}}
												/>
											</FormControl>
											<FormControl sx={{ m: 1, width: 240 }}>
												<CustomSelect
													name="Project"
													id="outlined-Project"
													options={ProjectChoices}
													onBlur={props.handleBlur}
													value={props.values.Project}
													error={props.touched.Project && Boolean(props.errors.Project)}
													helperText={props.touched.Project && props.errors.Project}
													label="Project"
													disabled={data.IsBilled === 1}
													onChange={(e) => {
														setProjectOption(e.target.value);
														handleProjectChange(e.target.value);
													}}
												/>
											</FormControl>
										</div>
										<div>
                                            <FormControl sx={{ m: 1, width: 240 }}>
                                                <TextField
                                                    name='Name'
                                                    id="outlined-taskProp"
                                                    onChange={props.handleChange}
                                                    onBlur={props.handleBlur}
                                                    value={props.values.Name}
                                                    error={props.touched.Name && Boolean(props.errors.Name)}
                                                    helperText="AutoSet by selecting a Radio Button before setting Property"
                                                    label="Name"
                                                />
                                            </FormControl>
                                        </div>
                                        <div >
                                            <FormControl sx={{ m: 1 }}>
                                                <FormControlLabel
                                                    name="IsActive"
                                                    label="Active"
                                                    control={<Checkbox checked={props.values.IsActive} onChange={props.handleChange} />}
                                                />
                                            </FormControl>
                                        </div>
                                        <div>
                                            <FormControl sx={{ m: 1 }}>
                                                <FormControlLabel
                                                    name="IsBillable"
                                                    label="Billable"
                                                    disabled={data.IsBilled === 1}
                                                    control={<Checkbox checked={props.values.IsBillable} onChange={props.handleChange} />}
                                                />
                                            </FormControl>
                                        </div>
                                     </Grid>
                                    <Grid item xs={8}> 
                                       {(!isLoaded) ?

                                            <Box sx={{ height: 300 }}>
                                                <Fade
                                                    in={(!isLoaded)}
                                                    style={{
                                                        transitionDelay: isLoaded ? '800ms' : '0ms',
                                                    }}
                                                    unmountOnExit
                                                >
                                                    <Stack sx={{ color: 'grey.500' }} spacing={2} direction="row" justifyContent="center">
                                                        <CircularProgress color="secondary" />
                                                        <CircularProgress color="success" />
                                                        <CircularProgress color="inherit" />
                                                    </Stack>
                                                </Fade>
                                            </Box>
                                            :
                                            <Box>
                                  
                                                <FieldArray name="propList">
                                                    {({ push, remove }) => (
                                                        <div>
                                                            <RadioGroup
                                                                name="radio-buttons-group"
                                                                value={radio}
                                                                onChange={(event) => {
                                                                    setRadio(event.target.value)
                                                                }}>
																{logger("props.values----", props.values)}
																{props.values.propList.map((p, index) => {
																	logger("p", p)
																	
																	const TaskItem = `propList[${index}].TaskItem`;
																	const touchedTaskItem = getIn(props.touched, TaskItem);
																	const errorTaskItem = getIn(props.errors, TaskItem);
																	logger("props.values.propList before ", props.values.propList)
																	setTaskPropItemValue(p, props, index);
																	logger("Taskitem ",TaskItem )

                                                                    return (
                                                                        <Box>
                                                                         
                                                                            {optionList[index]?.IsDropdown ?
                                                                                <div key={p.id}>
                                                                                   
                                                                                    <FormControl sx={{ m: 1, width: 240, display: "flex", flexDirection: "row" }}>
                                                                                        <FormControlLabel key='radio-{TaskItem}'  value={props.values.propList[index].TVName} control={<Radio />} />
                                                                                        <InputLabel shrink htmlFor='outlined-{TaskItem}'>{props.values.propList[index].TVName}</InputLabel>
                                                                                        <Autocomplete
                                                                                            freeSolo={true}
                                                                                            id='outlined-{TaskItem}'
                                                                                            name={TaskItem}
                                                                                            key={TaskItem}
                                                                                            options={taskItemChoices.filter(taskItem => taskItem.TaskVariableID == p.TaskVariableID)}
                                                                                            getOptionLabel={(option) => option?.label || option?.toString() || ''}
                                                                                            defaultValue = {taskItemChoices.filter(taskItem => taskItem.value == initialValues.propList[index].TaskItem)[0]}
                                                                                            style={{ width: 300 }}                                     
                                                                                            label={props.values.propList[index].TVName}
                                                                                            onInputChange={(e) => {
                                                                                                logger("onInputChange", e)
                                                                                                if (e != null) {
																									setNewItem({ Name: e.target.value, TaskVariableID: p.TaskVariableID, VariableName: p.TVName, isNew: taskItemChoices.filter(taskItem => taskItem.label == e.target.value).length > 0 ? false : true })
                                                                                                }
                                                                                            }}                                                                                            
																							                                                                                          
																							onChange={(e, value) => {
																								logger("taskItem in Onchange",TaskItem )
																								logger("Event", e);
																								logger("Selected Value", value);
																								// Check if the value is undefined or does not exist in taskItemChoices
																								if (!value || value.value === undefined) {
																									logger(`Names: ${p.TVName} TaskVariableID: ${p.TaskVariableID} value: ${value} `);
																									const itemExists = taskItemChoices.some(
																										taskItem => taskItem.TaskVariableID === p.TaskVariableID && taskItem.label === value
																									);

																									if (!itemExists && value) {
																										setNewItem({ Name: value, TaskVariableID: p.TaskVariableID, VariableName: p.TVName, isNew: true });
																										setAlert(true);
																									} else {
																										setNewItem({ Name: value, TaskVariableID: p.TaskVariableID, VariableName: p.TVName, isNew: false });
																										logger("Item already exists, no need to trigger alert.");
																									}

																								} else {
																									logger("Existing item selected:", value);
																									logger("P.Name", p.TVName)
																									logger("Radio", radio)
																									if (p.TVName === radio) {
																										const newName = `${p.TVName}-${value.label}`;
																										logger("Setting Name to:", newName);
																										props.setFieldValue("Name", newName, false);
																										logger("Setting Name After  :", newName);
																										logger("props.values.Name in onchange Existing item ", props.values.Name)
																									}
																									props.setFieldValue(
																										`${TaskItem}`,
																										value !== null ? value.value : initialValues.propList[e].TaskItem
																									);

																									setNewItem({ Name: value.label, TaskVariableID: p.TaskVariableID, VariableName: p.TVName, isNew: false });
																								}
																							}}
																							
																							renderInput={params => (
																								<>
																									<TextField
																										margin="normal"
																										key={TaskItem}
																										label={p.TVName}
																										name={TaskItem}
																										{...params}
																									/>
																								</>
																							)}
																						/>
																						<Tooltip title="SAVE" placement="top-end">
																							<IconButton color="primary" sx={{ p: '10px' }} aria-label="AddNewOption" 
																							disabled={checkDisabled(newItem, p)}
																								onClick={() => {
																									logger("newItem", newItem)
																									handleAlert(newItem.Name, newItem.TaskVariableID, newItem.VariableName);
																								}}
                                                                                            >
                                                                                                <AddCircleOutlineIcon />
                                                                                            </IconButton>
                                                                                        </Tooltip>
                                                                                        <Dialog
                                                                                            open={ValueAlert}
                                                                                            onClose={handleAlertClose}
                                                                                            aria-labelledby="alert-dialog-title"
                                                                                            aria-describedby="alert-dialog-description"
                                                                                        >
                                                                                            <DialogTitle id="alert-dialog-title">
                                                                                                {"Save New value"}
                                                                                            </DialogTitle>
                                                                                            <DialogContent>
                                                                                                <DialogContentText id="alert-dialog-description">
                                                                                                    Add {newItem.Name} To {newItem.VariableName}
                                                                                                </DialogContentText>
																							</DialogContent>
																							<DialogActions>
																								<Button onClick={() => { setAlert(false) }}>Disagree</Button>
																								<Button onClick={() => {
																									setAlert(false);
																									handleNewItem(newItem.Name, newItem.TaskVariableID, newItem.VariableName,radio);
																									logger("p.Name,radio",newItem.Name,"--TV--", newItem.VariableName, "----radio--", radio, "----",)
																									if (newItem.VariableName === radio) {
																										const newName = `${newItem.VariableName}-${newItem.Name}`;
																										logger("Setting Name to in Alert:", newName);
																										//props.setFieldValue("Name", newName, false);
																										setUpdateName(newName)
																										logger("updateName in onclick ", updateName)
																										logger("Setting Name after in Alert:", newName);																									}
																								}}>
                                                                                                    Agree
                                                                                                </Button>
                                                                                            </DialogActions>
                                                                                        </Dialog>
                                                                                    </FormControl>
                                                                                </div>
                                                                                :
                                                                                <div>
                                                                                    <FormControl sx={{ m: 1, width: 240 }}>
                                                                                        
                                                                                        <TextField
                                                                                            disabled
                                                                                            id="outlined-TaskItem"
                                                                                            key={TaskItem}
                                                                                            name={TaskItem}
                                                                                            labelId="outlined-{TaskItem}"
                                                                                            label={props.values.propList[index].TVName}
                                                                                        //    value={props.values.TaskType}

                                                                                        />
                                                                                    </FormControl>

                                                                                </div>
                                                                            }
                                                                        </Box>
                                                                    )
                                                                })}
                                                            </RadioGroup>
                                                        </div>
                                                    )}
                                                </FieldArray>
                                            </Box>

                                        }
                                    </Grid>
                                 </Grid>
                            </Form>
                        )}
                    </Formik>
                </DialogContent>
                <Dialog
                    open={saveAlert}
                    onClose={handleSaveAlertClose}
                    aria-labelledby="alert-title"
                    aria-describedby="alert-description"
                >
                    <DialogTitle id="alert-title">
                        {"SAVE FAILED"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-description">
                            The TASKNAME already exists, please select a unique TASKNAME
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => { setSaveAlert(false) }}>close</Button>
                    </DialogActions>
                </Dialog>
            </Dialog>
        </div>
    );
}
